import React, { Component } from 'react';
import styled from "styled-components";
import * as MDICONS from '@material-ui/icons';
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import EditProjectForm from './dashboardComponents/settings/EditProjectForm'
import ReactModal from 'react-modal';
import { openNewReportModal, openProjectUpdateModal } from '../../store/actions/projectActions';
import ErrorComponent from '../error/ErrorComponent';
import { get } from 'lodash'
import ProjectProfile from './ProjectProfile';
import MinimalProjectProfile from './MinimalProjectProfile';
import ProjectNotificationDrawer from '../notifications/ProjectNotificationDrawer';
import { compose } from 'redux';
import { firebaseConnect, firestoreConnect } from 'react-redux-firebase';
import ReportModal from '../reportGeneration/ReportModal';

const ProjectEditButton = styled.div`

    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.backgroundColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeHoverColor};
            background-color: ${(props) => props.themeColors.themeHoverColor};
        }

        &:active {
            color: ${(props) => props.themeColors.backgroundColor};
            border-color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.themeActiveColor};
        }
    }
`;

class ProjectDashboard extends Component {

    constructor(props) {
        super()

        this.state = {
            showEditFormModal: false,
            loadingError: false,
            showVisibleModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.props.openProjectUpdateModal();
        this.setState({ showEditFormModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showEditFormModal: false });
    }

    componentDidMount() {
        const { project, projectDatastore } = this.props;
        // console.log(project.proid);
        // console.log(projectDatastore[`${project.proid}`]);

        this.timerHandle = setTimeout(() => {
            this.setState({ loadingError: true });
            this.timerHandle = 0;
        }, 3000);
    }

    componentWillUnmount() {
        // Is our timer running?
        if (this.timerHandle) {
            // Yes, clear it
            clearTimeout(this.timerHandle);
            this.timerHandle = 0;
        }
    };

    /// README: MODAL CONTROLLING
    handleOpenReportModal = () => {
        this.props.openNewReportModal();
        this.setState({ showVisibleModal: true, });
    }

    handleCloseReportModal = () => {
        this.setState({ showVisibleModal: false });
    }

    render() {
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }

        const { snagDetail, alu, userData, themeColors, modalStyles, project } = this.props;
        const { isProjectUpdated } = project;
        const { uid, employeeid } = userData;
        const { projectDashboardAccess, projectDashboardOnlyAccess, seeProjectNotificationsAccess, isCompanyInsider } = alu;
        
        if (snagDetail) {
            const { projectTitle, accessMap } = snagDetail;

            /// getting ueid to pass into accessMap of project to get accessLevel
            var ueid = uid + employeeid;
            var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
            const reportGenButton = isCompanyInsider[accessLevel] ? (<button className="btn btn-default btn-sm" style={{ borderRadius: '10px' }} onClick={() => this.handleOpenReportModal()}>Generate report</button>) : (<React.Fragment></React.Fragment>);
            if (projectDashboardAccess[accessLevel]) {
                /// showing all the project dashboard components
                return (
                    <div className="container-fluid">
                        <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>

                            {/* EDIT MODAL */}
                            <ReactModal
                                style={modalStyles}
                                isOpen={this.state.showEditFormModal && !isProjectUpdated === true}
                                onRequestClose={() => { this.handleCloseModal() }}
                                contentLabel="Add new project"
                                ariaHideApp={false}
                            >
                                <button className="close" onClick={() => { this.handleCloseModal() }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <EditProjectForm />
                            </ReactModal>

                            {/* REPORT MODAL  */}
                            <ReactModal
                                style={modalStyles}
                                isOpen={this.state.showVisibleModal === true}
                                onRequestClose={() => { this.handleCloseReportModal() }}
                                contentLabel="report modal"
                                ariaHideApp={false}

                            >
                                <button className="close" onClick={() => { this.handleCloseReportModal() }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <ReportModal defectMarkers={this.props.commons.defectMarkers} />
                            </ReactModal>

                            {/* HEADER WITH SETTING */}
                            <h5 className="card-header" >
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center" style={{ width: "500px", textAlign: 'start' }}>

                                            <span className="" style={{ fontWeight: "bold" }}>{projectTitle}</span>
                                            <br />
                                            <span className="badge badge-pill px-3" style={{ backgroundColor: `${alu.color[accessLevel]}`, color: `${alu.textColor[accessLevel]}`, textAlign: "start", fontSize: "12px", fontStyle: "italic" }}>{alu.text[accessLevel]}</span>

                                        </div>
                                    </div>

                                    {/* PROJECT EDITING BUTTON */}
                                    {seeProjectNotificationsAccess[accessLevel] ?
                                        <div className="d-flex flex-row">
                                            <div className="align-self-center"> <ProjectNotificationDrawer /></div>
                                            &nbsp; &nbsp;
                                            <div className="align-self-center">
                                                <div className="d-flex flex-column">
                                                    <div className="align-self-end">
                                                        
                                                        <ProjectEditButton themeColors={themeColors}>
                                                            <button className="btn btn-default btn-sm" style={{ borderRadius: '10px' }} onClick={this.handleOpenModal}>
                                                                {/* <MDICONS.Edit /> {" "} Edit project */}
                                                                Edit project
                                                            </button>
                                                            {reportGenButton}
                                                        </ProjectEditButton>
                                                        

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : <React.Fragment />}
                                </div>
                            </h5>
                            {projectDashboardOnlyAccess[accessLevel] ? <ProjectProfile /> : <MinimalProjectProfile />}
                        </div>
                    </div>
                )

            }
            else {
                return (
                    <div className="container-fluid">
                        <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>
                            {/* HEADER WITH SETTING */}
                            <h5 className="card-header" >
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center" style={{ width: "300px" }}>
                                            <span style={{ fontWeight: "bold" }}>Error: Page not found</span>
                                        </div>
                                    </div>
                                </div>
                            </h5>

                            {/* MAIN BODY WITH CARDS */}
                            <div className="container-fluid py-3">
                                <div className="card">
                                    <div className="card-body">
                                        <h6><b>Please go back to home page!</b></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        /// SHOW ERROR (when snagDetail is null)
        else if (snagDetail === undefined || snagDetail === null) {
            if (this.state.loadingError) {
                return (
                    <div className="container-fluid">
                        <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '80px' }}>
                            {/* HEADER WITH SETTING */}
                            <h5 className="card-header" >
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row">
                                        <div className="align-self-center" style={{ width: "300px" }}>
                                            <span style={{ fontWeight: "bold" }}>Error</span>
                                        </div>
                                    </div>
                                </div>
                            </h5>

                            {/* MAIN BODY WITH CARDS */}
                            <div className="container-fluid py-3">
                                <div className="card">
                                    <div className="card-body">
                                        <h1>404: Page not found</h1>
                                        <br />
                                        <Link to={ROUTES.HOME_PROJECTS}><button className="btn btn-outline-dark">Please go back to home page!</button></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="container-fluid">
                        <div className="" style={{ marginLeft: this.props.dashboardSidebarSize, marginTop: '150px' }}>
                            <div className="card p-3 pt-5">
                                <Loader
                                    type="TailSpin"
                                    color={this.props.themeColors.themeColor}
                                    height={50}
                                    width={50}
                                />
                                <br></br>
                                <p style={textStyle}>Fetching your project...</p>
                                <br></br>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        alu: state.alu,
        userData: state.firebase.profile,
        modalStyles: state.appControl.modalStyles,
        auth: state.firebase.auth,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commons: state.commons,
        // project specifics
        projectCompany: state.firestore.data.ProjectCompany,
        projectProductOrder: state.firestore.data.ProjectProductOrder,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openProjectUpdateModal: () => dispatch(openProjectUpdateModal()),
        openNewReportModal: () => dispatch(openNewReportModal()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDashboard)
// export default compose(
//     connect(mapStateToProps, mapDispatchToProps),
//     firebaseConnect((props) => {
//         let proid = props.project.proid;
//         return [
//             `ProjectsMeta/${proid}/Notifications`
//         ]
//     }),
//     firestoreConnect((props) => {
//         let proid = props.project.proid;
//         let coidOfProid = props.snagDetail ? props.snagDetail.coid : "-1";
//         return [
//             {
//                 collection: `Projects/${proid}/Notifications`,
//                 orderBy: ['timestamp', 'desc'],
//                 storeAs: "ProjectNotifications",
//             },
//             {
//                 collection: "Companies",
//                 storeAs: "ProjectCompany",
//                 doc: coidOfProid
//             },
//         ]
//     })
// )(ProjectDashboard);